import Modal from "../Modal";
import CompanyBranchEditForm from "../../forms/company/CompanyBranchEditForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function CompanyBranchEditModal({show, handleClose, company_id, company_branch, callback, title = null}) {
    const { t } = useTranslation();
    const defaultTitle = t("companyBranch.edit");
    return (
        <Modal title={title || defaultTitle} show={show} handleClose={handleClose}>
            <CompanyBranchEditForm handleClose={handleClose} company_branch={company_branch} company_id={company_id} callback={callback} />
        </Modal>
    );
};